// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogtreeBox[data-v-1bec6934]{margin-top:.521vw;height:15.625vw;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
